import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import LogoSVG from '../Navbar/LogoSVG';
import './Footer.css';

const IconFacebook = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
  </svg>
);

const IconLinkedIn = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
    <rect x="2" y="9" width="4" height="12"/>
    <circle cx="4" cy="4" r="2"/>
  </svg>
);

const COMPANY_LINKS = [
  { label: 'Inicio',       href: '#hero' },
  { label: 'Nosotros',     href: '#about' },
  { label: 'Proyectos',    href: '#projects' },
  { label: 'Experiencias', href: '#services' },
  { label: 'Contacto',     href: '#contact' },
];

const SERVICES_LINKS = [
  'Supervisión de Obra',
  'Infraestructura Civil',
  'Edificaciones',
  'Proyectos Corporativos',
  'Remodelaciones y Adecuaciones',
  'Diseño e Ingeniería',
];

const IconCalidad = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <path d="M14 3L17 10H24L18.5 14.5L20.5 22L14 18L7.5 22L9.5 14.5L4 10H11L14 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);

const IconSeguridad = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <path d="M14 3C9.6 3 5.9 6.5 5.8 11H5C4.4 11 4 11.4 4 12V14c0 .6.4 1 1 1h18c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1h-.8C22.1 6.5 18.4 3 14 3Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
    <line x1="14" y1="3" x2="14" y2="11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="4" y1="18" x2="24" y2="18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M7 18L6 25H22L21 18" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
  </svg>
);

const IconPlanificacion = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <rect x="5" y="4" width="18" height="21" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
    <line x1="9" y1="9" x2="19" y2="9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
    <line x1="9" y1="13" x2="19" y2="13" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
    <line x1="9" y1="17" x2="14" y2="17" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
    <path d="M15 19l3-3 2 2-3 3h-2v-2Z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/>
  </svg>
);

const IconCumplimiento = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
    <rect x="5" y="4" width="18" height="21" rx="1.5" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M10 14l3 3 5-5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    <line x1="9" y1="9" x2="19" y2="9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
  </svg>
);

const PRINCIPIOS = [
  {
    Icon: IconCalidad,
    title: 'Calidad',
    desc: 'Aplicamos estándares rigurosos para asegurar resultados confiables y duraderos.',
  },
  {
    Icon: IconSeguridad,
    title: 'Seguridad',
    desc: 'Priorizamos la seguridad en cada proyecto, protegiendo a las personas y garantizando procesos responsables.',
  },
  {
    Icon: IconPlanificacion,
    title: 'Planificación',
    desc: 'Organizamos cada etapa del proyecto para optimizar tiempos y resultados.',
  },
  {
    Icon: IconCumplimiento,
    title: 'Cumplimiento',
    desc: 'Cumplimos con normativas y requisitos para garantizar proyectos exitosos.',
  },
];

const Footer = () => {
  const navigate = useNavigate();

  const handleNav = (e, href) => {
    e.preventDefault();
    if (window.location.pathname !== '/') {
      navigate('/' + href);
    } else {
      document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">

          {/* Brand */}
          <div className="footer__brand">
            <div className="footer__logo-wrap">
              <a
                href="/"
                onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                aria-label="Ir al inicio"
              >
                <LogoSVG height={52} showTagline={false} />
              </a>
            </div>
            <p className="footer__brand-desc">
              Confía en nosotros para desarrollar proyectos con calidad, responsabilidad
              y respaldo técnico. Nuestro compromiso con la correcta ejecución y la atención
              en cada detalle nos permite ofrecer soluciones confiables para cada necesidad
              constructiva.
            </p>
            <p className="footer__cta-line">
              <a href="#contact" className="footer__cta-link" onClick={(e) => handleNav(e, '#contact')}>
                Contáctanos
              </a>
              {' '}y hagamos realidad tu próximo proyecto.
            </p>
            <div className="footer__social">
              <a
                href="https://www.facebook.com/share/186w29GJjX/?mibextid=wwXIfr"
                className="footer__social-link"
                aria-label="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconFacebook />
              </a>
              <a
                href="https://www.linkedin.com/company/consuprog/"
                className="footer__social-link"
                aria-label="LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <IconLinkedIn />
              </a>
            </div>
          </div>

          {/* Empresa */}
          <nav className="footer__col" aria-label="Empresa">
            <p className="footer__col-title">Empresa</p>
            <ul className="footer__nav">
              {COMPANY_LINKS.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="footer__nav-link" onClick={(e) => handleNav(e, link.href)}>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Servicios */}
          <nav className="footer__col" aria-label="Servicios">
            <p className="footer__col-title">Servicios</p>
            <ul className="footer__nav">
              {SERVICES_LINKS.map((s) => (
                <li key={s}>
                  <a href="#services" className="footer__nav-link" onClick={(e) => handleNav(e, '#services')}>
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          {/* Principios */}
          <div className="footer__col">
            <p className="footer__col-title">Principios de trabajo</p>
            <div className="footer__principios">
              {PRINCIPIOS.map(({ Icon, title, desc }) => (
                <div key={title} className="footer__principio">
                  <div className="footer__principio-icon">
                    <Icon />
                  </div>
                  <div>
                    <div className="footer__principio-title">{title}</div>
                    <div className="footer__principio-desc">{desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="footer__bottom">
          <p className="footer__copy">
            © {new Date().getFullYear()} <span>Consuprog</span> — Todos los derechos reservados. Honduras.
          </p>
          <div className="footer__legal">
            <Link to="/privacidad" className="footer__legal-link">Privacidad</Link>
            <Link to="/terminos" className="footer__legal-link">Términos</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
